import React, { useEffect, useState } from "react";
import { Container_List } from "../components/Container_List";
import request from "../../Helpers/API";
import Swal from "sweetalert2";

export const CreditoMainScreen = () => {
  const [cards, setCards] = useState([]);
  useEffect(() => {
    request
      .get(`MenuUsuarios/AccesosMenus?idmodulo=9`)
      .then((result) => {
        const cards_array = result.map((item) => ({
          titulo: item.titulo,
          ruta: item.ruta,
        }));
        localStorage.removeItem("filtroEstado");
        setCards(cards_array);
      })
      .catch((error) => {
        Swal.fire("MENUS COBRANZA", JSON.stringify(error), "error");
      });
  }, []);
  return <Container_List titulo={"CONFIGURACIONES DE CREDITO"} cards={cards} />;
};
